import React from 'react'
import './NavbarLinks.css'
import {Link} from 'react-scroll'

const NavbarLinks = () => {
  return (
    <div className="navbarLinks-container">
        <a href="https://www.zara.com/in/en/man-new-in-l711.html?v1=2112866"   className='navlinks active'>NEW</a>
        <a href='https://www.zara.com/in/en/man-jeans-l659.html?v1=2113323' className='navlinks'>JEANS</a>
        <a href='https://www.zara.com/in/en/zara-athleticz-stories-l4713.html?v1=2112929' className='navlinks'>ZARA ATHLETICZ</a>
        <a href='https://www.zara.com/in/en/man-office-l713.html?v1=2119861' className='navlinks'>BACK TO WORK</a>
        <a href='https://www.zara.com/in/en/sustainability-clothing-care-mkt3129.html?v1=1596204' className='navlinks'>CLOTHING CARE</a>
    </div>
  )
}

export default NavbarLinks